import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationPermissionBannerComponent } from './notification-permission-banner.component';

@NgModule({
  declarations: [NotificationPermissionBannerComponent],
  imports: [CommonModule],
  exports: [NotificationPermissionBannerComponent]
})
export class NotificationPermissionBannerModule {}
